import { CircularProgress, Grid, Paper } from "@mui/material";
import React from "react";

export const Loader = React.memo(() => (
	<Paper sx={{ height: "100%" }}>
		<Grid container justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
			<CircularProgress />
		</Grid>
	</Paper>
));